import type * as THREE from "three";

/**
 * Shoelace area of the ring projected onto XZ. Positive when the ring winds counter-clockwise
 * in (x, z), which is what the offset helpers use to decide which side of an edge is "outside".
 */
function signedArea({ points }: { points: ReadonlyArray<THREE.Vector3> }): number {
	if (points.length < 3) {
		return 0;
	}

	let doubledArea = 0;

	for (let index = 0; index < points.length; index++) {
		const current = points[index];
		const next = points[(index + 1) % points.length];
		doubledArea += current.x * next.z - next.x * current.z;
	}

	return doubledArea / 2;
}

export { signedArea };
